<template>
    <div>
        <br/>
        <form class="form-horizontal" v-if="! ibutton">
            <div class="form-group">
                <div class=" col-sm-3">
                    <button @click="solicitar()" type="button" class="btn btn-block btn-xs btn-warning">
                        <i class="fa fa-save"></i> SOLICITAR IBUTTONS</button>
                </div>

                <div class=" col-sm-3">
                    <button @click="ibutton = {}" type="button" class="btn btn-block btn-xs btn-success">
                        <i class="fa fa-plus"></i> EMBARCAR IBUTTONS
                    </button>
                </div>

                <div class=" col-sm-3">

                </div>

                <div class=" col-sm-3" v-if="ibuttons.length">
                    <button @click="addAll()" type="button" class="btn btn-block btn-xs btn-danger">
                        <i class="fa fa-plus"></i> CADASTRAR TODOS OS IBUTTONS
                    </button>
                </div>
            </div>
        </form>

        <div v-if="! ibutton && ibuttons.length">
            Total: <b>{{ibuttons.length}} Ibuttons</b>
            <table class="table table-bordered table-striped" >
                <thead style="background-color: #1c699d; color: white;">
                <tr>
                    <td class="text-center" style="width: 80px; padding: 10px">NUM</td>
                    <td class="text-left" style=" padding: 10px">SERIAL <input type="text" v-model="serial_search" class="form-control" id="imei" placeholder="Serial"></td>
                    <td class="text-center" style="width: 100px; padding: 10px" v-if="id_cliente"></td>
                </tr>
                </thead>
                <tbody >
                <tr v-for="i in ibuttonsFilter">
                    <td style="vertical-align: center" class="text-center">{{ i.position }}</td>
                    <td style="vertical-align: center">{{ i.serial }}</td>
                    <td class="text-center" v-if="id_cliente">
                        <button type="button" @click="add(i.serial)" class="btn btn-xs btn-info">
                            CADASTRA NO CLIENTE
                        </button>
                    </td>
                </tr>
                </tbody >
            </table>

            <button @click="ibutton = {}" type="button" class="btn btn-xs btn-success">
                <i class="fa fa-plus"></i> CADASTRAR IBUTTONS
            </button>
        </div>


        <div v-else-if="ibutton">
            <form class="form-horizontal" >

                <div class="form-group">
                    <div class=" col-sm-10">

                        <div class="form-group ">
                            <div class="col-sm-offset-2 col-sm-10">
                                <button @click="ibutton = null" type="button" class="btn btn-xs btn-default">
                                    <i class="fa fa-step-backward"></i> CANCELAR
                                </button>
                            </div>
                        </div>

                        <div class="form-group"  style="margin-top: 20px">
                            <label for="imei" class="col-sm-2 control-label">SERIAL:</label>
                            <div class="col-sm-3">
                                <input type="text" v-model="ibutton.serial" class="form-control" id="imei" placeholder="Serial">
                            </div>
                        </div>

                        <div class="form-group" >
                            <div>
                                <label class="col-sm-2 control-label">POSIÇÃO:</label>
                                <div class="col-sm-4">
                                    <input type="number" v-model="ibutton.position" class="form-control" id="imei">
                                </div>
                            </div>

                        </div>

                        <div class="form-group ">
                            <div class="col-sm-offset-2  col-sm-10">
                                <button @click="cadastrar()" type="button" class="btn btn-xs btn-success">
                                    <i class="fa fa-save"></i> SALVAR IBUTTONS</button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>

        <div v-else>
            <h3>Nenhum IButton Adicionado</h3>
        </div>
    </div>
</template>

<script>
import {Ibutton, Rastreador, Suntech} from '../../class';
import {Bus} from '../../class/bus';

    export default {
        name: "ListagemIbuttons",
        props: {
            id_rastreador: {
                default: null
            },
            id_cliente: {
                default: null
            }
        },
        data () {
            return {
                serial_search: null,
                ibuttons: [],
                ibutton: null
            }
        },
        beforeMount() {
            this.load();
        },
        computed: {
            // a computed getter
            ibuttonsFilter:  function () {
                if (! this.serial_search) {
                    return this.ibuttons;
                }
                // `this` points to the vm instance
                return this.ibuttons.filter((e) => {
                    return String(e.serial).includes(this.serial_search);
                })
            }
        },
        methods: {
            solicitar () {
                Suntech.solicitarIbutton(this.id_rastreador);
                Bus.$emit('comandos');
            },
            load () {
                Rastreador.ibuttons(this.id_rastreador).then((data) => {
                    this.ibuttons = data;
                });
            },
            addAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente cadastrar este ibutton no cliente?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode cadastrar!'
                }).then(async () => {
                    try {
                        await Ibutton.saveAll({
                            id_rastreador: this.id_rastreador,
                            id_cliente: this.id_cliente,
                        });
                        return toastr.success("Cadastrado com sucesso!");
                    } catch (e) {
                        if (e.status === 402) {
                            return toastr.error(e.data.error);
                        }
                    }
                });
            },
            add(serial) {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente cadastrar este ibutton no cliente?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode cadastrar!'
                }).then(async () => {
                    try {
                        await Ibutton.save({
                            serial: serial,
                            id_cliente: this.id_cliente,
                        });
                        return toastr.success("Cadastrado com sucesso!");
                    } catch (e) {
                        if (e.status === 402) {
                            return toastr.error(e.data.error);
                        }
                    }
                });
            },
            cadastrar () {
                Suntech.cadastrarIbutton(this.id_rastreador, this.ibutton).then(() => {
                    this.load();
                    this.ibutton = null;
                    Bus.$emit('comandos');
                });
            }
        }
    }
</script>

<style scoped>

</style>
